"use client";

import { useEffect, useState } from "react";
import { getSupportedEducationCountries } from "@/config/general/education-discovery";
import { resolveVisitorCountry } from "@/lib/location/visitorCountry";

export type EducationAvailability =
  | { status: "loading" | "unknown"; countryCode: null }
  | { status: "supported" | "unsupported"; countryCode: string };

export const useEducationAvailability = () => {
  const [availability, setAvailability] = useState<EducationAvailability>({ status: "loading", countryCode: null });
  const [attempt, setAttempt] = useState(0);

  useEffect(() => {
    let active = true;
    void resolveVisitorCountry().then((countryCode) => {
      if (!active) return;
      setAvailability(countryCode
        ? { status: getSupportedEducationCountries().includes(countryCode) ? "supported" : "unsupported", countryCode }
        : { status: "unknown", countryCode: null });
    });
    return () => { active = false; };
  }, [attempt]);

  const retry = () => {
    setAvailability({ status: "loading", countryCode: null });
    setAttempt((previous) => previous + 1);
  };

  return { ...availability, retry };
};